import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Close';
import useTheme from '@mui/styles/useTheme';

type SearchTextFieldProps = {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly placeholder?: string;
  readonly showClearButton?: boolean;
};

export function SearchTextField({
  value,
  onChange,
  placeholder = 'Search',
}: SearchTextFieldProps) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  return (
    <TextField
      fullWidth
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={e => onChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              aria-label="Clear search"
              onClick={() => onChange('')}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : undefined,
      }}
      sx={{
        maxWidth: 460,
        '& .v5-MuiInputBase-root': {
          bgcolor: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(15,20,30,0.04)',
          borderRadius: '50px',
          '& fieldset': {
            borderRadius: '50px',
          },
        },
        '& .v5-MuiInputBase-input::selection': {
          backgroundColor: 'transparent',
        },
        '& .v5-MuiInputBase-input:-webkit-autofill, & .v5-MuiInputBase-input:-webkit-autofill:hover, & .v5-MuiInputBase-input:-webkit-autofill:focus, & .v5-MuiInputBase-input:-webkit-autofill:active':
          {
            WebkitBoxShadow: '0 0 0 100px transparent inset !important',
            WebkitTextFillColor: `${theme.palette.text.primary} !important`,
          },
      }}
    />
  );
}
